<div class="welcome-banner">
  <div class="titles">
    <div class="title1">
      {{ header || ("generic.main.hello" | translate) }}
      <div class="pulse">&nbsp;{{ currentUser.userData?.fullName }}</div>
    </div>
    <div class="title2">{{ title | translate }}</div>
  </div>
</div>
